{
  "version": 1,
  "asset_id": "cb4f220f-6215-432a-85b0-812a284101cf",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/cb4f220f-6215-432a-85b0-812a284101cf/hiatal-type-iv-upper-gi-es-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/cb4f220f-6215-432a-85b0-812a284101cf/hiatal-type-iv-upper-gi-es-480.webp",
  "original_filename": "hiatal-type-iv-upper-gi-es-480.webp",
  "size": 20200,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:33Z"
}
